import axios from 'axios';
import { createBrowserHistory } from 'history';
import queryString from 'query-string';
import { ENV } from '~/config/enviroment';
import authAPI from './AuthAPI';
import config from '~/config';

const history = createBrowserHistory({ window });

// REACT_APP_API_DEVELOPMENT=https://hitek-02.hitek.com.vn:6062/api/v1    //yarn build && firebase deploy --only hosting:abeauty-web-dev
// REACT_APP_API_PRODUCTION=https://api.vbeauty.com.vn/api/v1             // yarn build && firebase deploy --only hosting:abeauty-web
// REACT_APP_API_STAGING=https://hitek-02.hitek.com.vn:6066/api/v1         //yarn build && firebase deploy --only hosting:abeauty-web-staging

const getBaseURL = (str = 'production') => {
    if (str === 'production') {
        return ENV_PRODUCTION;
    } else if (str === 'dev') {
        return ENV_DEVELOPMENT;
    } else if (str === 'staging') {
        return ENV_STAGING;
    }
};

const ENV_PRODUCTION = process.env.REACT_APP_API_PRODUCTION; // yarn build && firebase deploy --only hosting:abeauty-web // Build for Production
const ENV_DEVELOPMENT = process.env.REACT_APP_API_DEVELOPMENT; //yarn build && firebase deploy --only hosting:abeauty-web-dev //Build for development
const ENV_STAGING = process.env.REACT_APP_API_STAGING; //	yarn build && firebase deploy --only hosting:abeauty-web-staging //Build for Staging

const axiosClient = axios.create({
    baseURL: getBaseURL(ENV),
    headers: {
        'Content-Type': 'application/json',
        env: ENV,
        platform: 'web',
        // localhost: 'web',
        //chi de khi o localhost, remove khi build.
    },
    paramsSerializer: (params) => queryString.stringify(params),
});

axios.defaults.baseURL = getBaseURL(ENV);

axiosClient.interceptors.request.use(async (config) => {
    const token = JSON.parse(localStorage.getItem('token'));

    if (!!token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

axiosClient.interceptors.response.use(
    (response) => {
        if (response && response.data) {
            return response.data;
        }

        return response;
    },
    async (error) => {
        // const userInfo = useSelector((state) => state.user.userInfo);
        // const isLogin = userInfo?.id || '';
        const isLogin = !!localStorage.getItem('token') || '';
        console.log('Khiem error axios,', error);
        if (isLogin) {
            if (error?.response?.status === 401) {
                try {
                    const refreshTokenLocal = localStorage.getItem('refreshToken') || '';
                    const originalRequest = error.config;
                    const body = {
                        refresh_token: refreshTokenLocal,
                    };

                    const resRefresh = await authAPI.refreshToken(body);

                    const token = resRefresh?.results?.object?.token;
                    const refreshToken = resRefresh?.results?.object?.refreshToken;

                    localStorage.setItem('token', JSON.stringify(token));
                    localStorage.setItem('refreshToken', refreshToken);

                    return axiosClient(originalRequest);
                } catch (err) {
                    if (err?.code === 409) {
                        localStorage.clear();
                        window.postMessage('NotAuthorized');
                        history.replace(config.routes.login);
                        window.location.reload();
                        return Promise.resolve();
                    }
                }
            }
        }

        if (error?.response?.status === 555) {
            localStorage.clear();
            window.postMessage('NotAuthorized');
            history.replace(config.routes.login);
            window.location.reload();
            return Promise.resolve();
        }

        // Handle errors
        // return Promise.reject(error.response?.data);
        throw error.response?.data;
    },
);

export default axiosClient;
